/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
window.lockScroll = function () {
  if (window.lenis && typeof window.lenis.stop === 'function') window.lenis.stop();
  document.documentElement.style.overflow = 'hidden';
};

window.unlockScroll = function () {
  if (window.lenis && typeof window.lenis.start === 'function') window.lenis.start();
  document.documentElement.style.overflow = '';
};

$(document).ready(function () {
  window.clickedFromPopupColor = false;

  function initHeaderAndSticky() {
    var $header = $(".homepageHeader_layout");
    var $section = $(".product-single");
    var $addons = $("addons-slider-top-wrapper");
    var $accordion = $("accordion-content");
    var $deskHeader = $(".desk_header-inner-container");
    var $anchorBox = $(".desk_product-anchor-outer_box");
    var $anchorPlaceholder = $(".desk_product-anchor-outer_box__placeholder");
    var $headerContainer = $(".desk_header-container");
    var $allProductHeader = $(".desk_all-product-header");
    var $allProductHeaderOuter = $(".desk_all-product-header-outer");

    function updateBelowSticking() {
      if (!$section.length) return;
      $section.toggleClass("below-sticking", $section.hasClass("is-sticking") && $deskHeader.hasClass("headerUp"));
    }

    function updateAnchorSticking() {
      if (!$anchorBox.length || !$anchorPlaceholder.length) return;
      var headerBottom = $headerContainer.length ? $headerContainer[0].getBoundingClientRect().bottom : 0;
      var placeholderTop = $anchorPlaceholder[0].getBoundingClientRect().top;
      var shouldStick = placeholderTop <= headerBottom;
      $anchorBox.toggleClass("anchor-sticking", shouldStick);
      $anchorBox.toggleClass("anchor-below-sticking", shouldStick && $deskHeader.hasClass("headerUp"));
    }

    function updateAllProductHeaderSticking() {
      if (!$allProductHeader.length || !$allProductHeaderOuter.length) return;
      var headerBottom = $headerContainer.length ? $headerContainer[0].getBoundingClientRect().bottom : 0;
      var outerTop = $allProductHeaderOuter[0].getBoundingClientRect().top;
      var shouldStick = outerTop <= headerBottom;
      $allProductHeader.toggleClass("headerFixed", shouldStick);
      $allProductHeader.toggleClass("headerFixedBottom", shouldStick && $deskHeader.hasClass("headerUp"));
      $(".all-products-body__filters.is-visible").toggleClass("headerScrollingUp", shouldStick && $deskHeader.hasClass("headerUp"));
    }

    function onScroll() {
      if ($header.length) {
        if ($(window).scrollTop() > 30) {
          $header.removeClass("positioned_top");
        } else {
          $header.addClass("positioned_top");
        }
      }

      if ($section.length) {
        // End the sticky ATC when the next block scrolls near the top. Use the addons
        // block if the template has one; otherwise fall back to <accordion-content>
        // (templates without addons) so it still un-sticks when that comes into view.
        var $liveAddons = $addons.not('.desk_steps-flow--ready addons-slider-top-wrapper').filter(':visible');
        var $stopEl = $liveAddons.length ? $liveAddons : $accordion;
        var stopReached = $stopEl.length && $stopEl[0].getBoundingClientRect().top <= window.innerHeight * 0.3;
        $section.toggleClass("is-sticking", window.scrollY >  300 && !stopReached && !window.deskGallerySlideLocked);
        updateBelowSticking();
      }

      updateAnchorSticking();
      updateAllProductHeaderSticking();
    }

    if ($deskHeader.length) {
      new MutationObserver(function () {
        updateBelowSticking();
        updateAnchorSticking();
        updateAllProductHeaderSticking();
      }).observe($deskHeader[0], { attributes: true, attributeFilter: ["class"] });
    }

    $(window).on("scroll", onScroll);
    onScroll();
  }

  initHeaderAndSticky();

  $(".product__accordion-title").click(function () {
    $(this)
      .closest(".js--accordion--box")
      .find(".product__accordion-wrapper")
      .toggleClass("open");
    $(this)
      .closest(".js--accordion--box")
      .find(".product__accordion-triger")
      .toggleClass("active");
    $(".wrapper-in .add--one--modal").toggleClass("popup_positioned_top");
  });

  $(".product__accordion-triger").click(function () {
    $(this)
      .closest(".js--accordion--box")
      .find(".product__accordion-wrapper")
      .toggleClass("open");
    $(this)
      .closest(".js--accordion--box")
      .find(".product__accordion-triger")
      .toggleClass("active");
    $(".wrapper-in .add--one--modal").toggleClass("popup_positioned_top");
  });

  $(".pp_footer_show_more").click(function () {
    $(".pp_footer_shorter_cont").hide();
    $(".pp_footer_longer_cont").show();
  });

  $(".pp_footer_show_less").click(function () {
    $(".pp_footer_shorter_cont").show();
    $(".pp_footer_longer_cont").hide();
  });

  function stopAllGalleryVideos() {
    window.pdpSwiper.slideTo(0);
    $(".product-single__media")
      .find("video")
      .each(function () {
        this.pause();
        this.currentTime = 0;
      });
  }

  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      // escape key maps to keycode `27`
      if ($(".add--one--modal").hasClass("open")) {
        $(".add--one--modal__close").trigger("click");
      }
      $("body").removeClass("popup-open");
      $(".pop-up.active video").each(function () {
        this.pause();
      });
      $(".pop-up").removeClass("active");
      $(".desk_popup_outer").hide();
      $("body").removeClass("no-scroll");

      $(".media--modal__images")
        .find("video")
        .each(function () {
          this.pause();
          this.currentTime = 0;
        });

      closeInfluPopup();
    }
  });

  $(".anchor-menu__item a").on("click", function (event) {
    if ($(window).width() < 960) {
      event.preventDefault();
      var $parentItem = $(this).parent();

      // Get the dimensions of the container and the clicked item
      var $menu = $(".anchor-menu");
      var containerWidth = $menu.outerWidth();
      var itemWidth = $parentItem.outerWidth();

      // Calculate the center position
      var itemOffsetLeft = $parentItem.position().left;
      var scrollPosition =
        $menu.scrollLeft() +
        itemOffsetLeft -
        containerWidth / 2 +
        itemWidth / 2;

      // Animate the scroll to the calculated position
      $menu.animate({ scrollLeft: scrollPosition }, 300);
    }
  });

  $(".desk_popup_outer").click(function (e) {
    if (
      !$(e.target).closest(
        ".desk_popup_inner, .desk_popup_next_btn, .desk_popup_prev_btn",
      ).length
    ) {
      $("body").removeClass("popup-open");
      $(".desk_popup_outer").hide();
    }
  });

  $(".pop-up__wrapper").click(function (e) {
    if (
      !$(e.target).closest(
        ".pop-up__content, .pop-up-inspired__buttons-wrapper",
      ).length
    ) {
      $("body").removeClass("popup-open");
      $(".desk_popup_outer").hide();
      $(".pop-up").removeClass("active");
      $("body").removeClass("no-scroll");
      $(e.target)
        .find("video")
        .each(function () {
          this.pause();
        });
    }
  });

  $(document).on("click", ".tabletops-banner__button", function () {
    $("body").addClass("popup-open");
    $(".desk_popup_outer").css("display", "flex");
    var currentData = $(this).attr("data-index");
    console.log(currentData);
  });

  $(document).on("click", ".textures__close", function () {
    $("body").removeClass("popup-open");
    $(".desk_popup_outer").hide();
    var currentData = $(this).attr("data-index");
    console.log(currentData);
  });

  // Popups out of stock functionality
  $(document).on("click", ".modal--variant__label", function () {
    var innerInput = $(this).find("input");
    if (innerInput.is(":disabled")) {
    } else {
      $(".modal--variant__label").removeClass("activelabel");
      $(this).addClass("activelabel");

      var currentVariant = $(this).attr("data-value-handle");
      var currentColor = $(".modal--color__label.activelabel")
        .find("span")
        .attr("data-color-handle");

      var fullTitle = currentColor + "-" + currentVariant;

      var productId = $(".add--one--modal__content").attr("data-product-id");

      var currentVariantId = "";

      $(".pa_label_variant__js").each(function () {
        if ($(this).attr("data-product-id") == productId) {
          if ($(this).attr("data-title") == fullTitle) {
            currentVariantId = $(this).attr("data-id");
          }
        }
      });

      checkAvailableColors();

      setTimeout(function () {
        $(".desktronic_loader3d_out").removeClass("active");
      }, 100);
    }
  });

  $(document).on("click", ".modal--color__label", function () {
    console.log("GOT THE CLICK");
    window.clickedFromPopup = true;
    const innerInput = $(this).find("input");
    if (innerInput.is(":disabled")) return;

    $(".modal--color__label").removeClass("activelabel");
    $(this).addClass("activelabel");

    const currentVariant = $(".modal--variant__label.activelabel").attr(
      "data-value-handle",
    );
    const currentColor = $(this).find("span").attr("data-color-handle");
    const fullTitle = currentColor + "-" + currentVariant;

    const productId = $(".add--one--modal__content").attr("data-product-id");
    let currentVariantId = "";

    var uniqueId = $(this).attr("data-unique-id");
    window.clickedFromPopupColor = true;
    setTimeout(function () {
      window.clickedFromPopupColor = false;
    }, 500);

    $('.add-one_color_option[data-product-id="' + productId + '"]')
      .find('.addone_color-option-out[data-unique-id="' + uniqueId + '"]')
      .trigger("click");

    $(".pa_label_variant__js").each(function () {
      if (
        $(this).attr("data-product-id") == productId &&
        $(this).attr("data-title") == fullTitle
      ) {
        currentVariantId = $(this).attr("data-id");
      }
    });

    const currentParentId = parseFloat(
      $(".add--one--modal__content").attr("data-parent-id"),
    );

    if (currentParentId > 0) {
      console.log(currentParentId, "TESTING");
      $(`.add-one-crossell__main[data-id="${currentParentId}"]`)
        .closest(".add-one-crossell")
        .find(
          `.product-single__add-one[data-id="${productId}"] .addonSwatcher_card`,
        )
        .each(function () {
          if (
            $(this).find(".swatch-color-ball").attr("data-color-handle") ==
            currentColor
          ) {
            $(".product-single__add-ons").attr("data-from-popup", "1");
            $(this).trigger("click");
            setTimeout(
              () => $(".product-single__add-ons").attr("data-from-popup", "0"),
              1000,
            );
          }
        });
    } else {
      $(
        `.product-single__add-one[data-id="${productId}"] .addonSwatcher_card`,
      ).each(function () {
        if (
          $(this).find(".swatch-color-ball").attr("data-color-handle") ==
          currentColor
        ) {
          $(".product-single__add-ons").attr("data-from-popup", "1");
          $(this).trigger("click");
          setTimeout(
            () => $(".product-single__add-ons").attr("data-from-popup", "0"),
            1000,
          );
        }
      });
    }

    checkAvailableSizes();

    setTimeout(function () {
      $(".desktronic_loader3d_out").removeClass("active");
    }, 100);
  });

  function checkAvailableSizes() {
    var currentVariantId;
    var productId = $(".add--one--modal__content").attr("data-product-id");
    var currentColor = $(".modal--color__label.activelabel")
      .find("span")
      .attr("data-color-handle");
    $(".modal--variant__label").each(function () {
      var currentSize = $(this).attr("data-value-handle");
      var fullTitleNew = currentColor + "-" + currentSize;
      var checkingLabel = $(this);
      // console.log(fullTitleNew, 'FULL TITLE');
      $(".pa_label_variant__js").each(function () {
        if ($(this).attr("data-product-id") == productId) {
          if ($(this).attr("data-title") == fullTitleNew) {
            currentVariantId = $(this).attr("data-id");
            var stock = $(this).attr("data-stock");
            if (stock == "1") {
              checkingLabel.removeClass("addone-switcher-label-out");
              checkingLabel.find("input").prop("disabled", false);
            } else {
              checkingLabel.addClass("addone-switcher-label-out");
              checkingLabel.find("input").prop("disabled", true);
            }
            // console.log('Sizes checked', currentVariantId, '===', stock);
          }
        }
      });
    });
  }

  function checkAvailableColors() {
    var currentVariantId;
    var productId = $(".add--one--modal__content").attr("data-product-id");
    var currentSize = $(".modal--variant__label.activelabel").attr(
      "data-value-handle",
    );
    $(".modal--color__label").each(function () {
      var currentColor = $(this).find("span").attr("data-color-handle");
      var fullTitleNew = currentColor + "-" + currentSize;
      var checkingLabel = $(this);
      console.log(fullTitleNew, "FULL TITLE");
      $(".pa_label_variant__js").each(function () {
        if ($(this).attr("data-product-id") == productId) {
          if ($(this).attr("data-title") == fullTitleNew) {
            currentVariantId = $(this).attr("data-id");
            var stock = $(this).attr("data-stock");
            if (stock == "1") {
              checkingLabel.removeClass("addone-color-label-out");
              checkingLabel.find("input").prop("disabled", false);
            } else {
              checkingLabel.addClass("addone-color-label-out");
              checkingLabel.find("input").prop("disabled", true);
            }
            console.log("Colors checked", currentVariantId, "===", stock);
          }
        }
      });
    });
  }

  $(document).on("click", ".add--one--modal__handler--box", function (event) {
    // 👉 catch the REAL clicked element
    const $target = $(event.target);

    // 🚫 If click happened inside disabled color label → do nothing
    if ($target.closest(".modal--color__label.addone-color-label-out").length) {
      return;
    }

    // ---- existing logic stays exactly the same ----
    const $clickedElement = $(this);
    const $checkbox = $clickedElement.find('input[type="checkbox"]');

    var dataId = $checkbox.attr("data-id");
    const dataProductId = $(".add--one--modal__content").attr(
      "data-product-id",
    );

    var currentId = "";
    if (
      $(".add--one--modal__handler--box").is(":empty") ||
      $(".add--one--modal__handler--box")
        .find(".addone_item-switch")
        .hasClass("active")
    ) {
      var id = $(".add--one--modal__handler--box[is-addone-modal-colors]")
        .find(".modal--color__label.activelabel")
        .find("span")
        .attr("data-variant-id");

      $(".addOneVariantSelection").removeClass("activeVariant");
      $(".addOneVariantSelection").each(function () {
        if ($(this).attr("data-id") == id) {
          $(this).addClass("activeVariant");
        }
      });
      currentId = id;
    } else {
      var color = $(".add--one--modal__handler--box[is-addone-modal-colors]")
        .find(".modal--color__label.activelabel")
        .find("span")
        .attr("data-color-handle");
      var size = $(".add--one--modal__handler--box[is-addone-modal-variants]")
        .find(".modal--variant__label.activelabel")
        .attr("data-value-handle");

      var fullTitle = color + "-" + size;

      $(".addOneVariantSelection").removeClass("activeVariant");
      $(".addOneVariantSelection").each(function () {
        if ($(this).attr("data-variant-title") == fullTitle) {
          $(this).addClass("activeVariant");
          currentId = $(this).attr("data-id");
        }
      });

      $(
        ".add--one--modal__handler--label input[is-addone-modal-checkbox]",
      ).attr("data-id", currentId);
    }

    var variantImageSource = $(".addOneVariantSelection.activeVariant").attr(
      "data-src",
    );

    if (currentId && window.renderAddOneGallery && window.addOneModalRefs) {
      window.renderAddOneGallery(
        dataProductId,
        currentId,
        window.addOneModalRefs,
        "",
      );
      $(".add-one_media_loader").css("display", "flex").addClass("activated");
      $(".add--one--modal__handler--label").addClass("loading");

      setTimeout(
        () => $(".add-one_media_loader").removeClass("activated"),
        900,
      );
      setTimeout(
        () => $(".add--one--modal__handler--label").removeClass("loading"),
        2000,
      );
      setTimeout(() => $(".add-one_media_loader").hide(), 1500);
    } else {
      console.warn(
        "Gallery renderer not ready or missing variant ID:",
        currentId,
      );
    }

    $(".variantImage__js-addone").attr("src", variantImageSource);
    $("[is-addone-modal-checkbox]").attr("data-id", currentId);
  });

  function scrollModalColorsToActive($box) {
    const $slider = $box.find(".modal--color__wrapper");
    if (!$slider.length) return;

    const $active = $slider.find(".modal--color__label.activelabel").first()
      .length
      ? $slider.find(".modal--color__label.activelabel").first()
      : $slider
          .find(".modal--color__label input:checked")
          .closest(".modal--color__label")
          .first();

    if (!$active.length) return;
    const sliderEl = $slider[0];
    const activeEl = $active[0];
    const target =
      activeEl.offsetLeft - sliderEl.clientWidth / 2 + activeEl.offsetWidth / 2;
    const max = sliderEl.scrollWidth - sliderEl.clientWidth;
    const clamped = Math.max(0, Math.min(target, max));
    $slider.stop(true).animate({ scrollLeft: clamped }, 0);
  }

  function updateModelSliderArrows($box) {
    const $slider = $box.find(".modal--color__wrapper");
    const $prev = $box.find(".modal--color__arrow--prev");
    const $next = $box.find(".modal--color__arrow--next");

    if (!$slider.length) return;

    const el = $slider[0];
    const maxScroll = Math.max(0, el.scrollWidth - el.clientWidth);
    const scrollLeft = el.scrollLeft;
    const EDGE = 2;
    if (maxScroll <= EDGE) {
      $prev.addClass("disableArrow");
      $next.addClass("disableArrow");
      return;
    }

    $prev.toggleClass("disableArrow", scrollLeft <= EDGE);
    $next.toggleClass("disableArrow", scrollLeft >= maxScroll - EDGE);
  }

  function renderModalColors(html, opts = {}) {
    const $box = $(".add--one--modal__handler--box[is-addone-modal-colors]");
    const colorsCount =
      opts.colorsCount ?? $(html).filter(".modal--color__label").length;
    const variantsCount =
      opts.variantsCount ??
      $(
        ".add--one--modal__handler--box[is-addone-modal-variants] .modal--variant__label",
      ).length;

    const doubleSwitchCount =
      opts.doubleSwitchCount ??
      $(
        ".add--one--modal__handler--box[is-addone-modal-variants] .addone_item-switch",
      ).length;

    const hasManyColors =
      opts.hasManyColors !== undefined
        ? opts.hasManyColors
        : colorsCount > 5 && (variantsCount > 1 || doubleSwitchCount >= 1);

    $box.empty();

    if (hasManyColors) {
      const $wrapper = $('<div class="modal--color__wrapper"></div>').appendTo(
        $box,
      );
      $wrapper.html(html);

      $box.append(`
        <span class="modal--color__arrow modal--color__arrow--prev">
          <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0511/8961/2733/files/Vector_83.png?v=1763462513">
        </span>
        <span class="modal--color__arrow modal--color__arrow--next">
          <img loading="lazy" src="https://cdn.shopify.com/s/files/1/0511/8961/2733/files/Vector_82.png?v=1763462513">
        </span>
      `);
    } else {
      $box.html(html);
    }

    requestAnimationFrame(() => {
      const $scope = $(
        ".add--one--modal__handler--box[is-addone-modal-colors]",
      );
      scrollModalColorsToActive($scope);
      updateModelSliderArrows($scope);
    });
  }

  $(document)
    .off("click.modalColorArrows")
    .on("click.modalColorArrows", ".modal--color__arrow", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $box = $(this).closest("[is-addone-modal-colors]");
      const $slider = $box.find(".modal--color__wrapper");
      if (!$slider.length) return;

      const step = 120;
      const isPrev = $(this).hasClass("modal--color__arrow--prev");
      const current = $slider.scrollLeft();

      $slider
        .stop(true)
        .animate({ scrollLeft: current + (isPrev ? -step : step) }, 200);
      setTimeout(() => updateModelSliderArrows($box), 220);
    });

  $(document)
    .off("scroll.modalColorWrapper")
    .on(
      "scroll.modalColorWrapper",
      "[is-addone-modal-colors] .modal--color__wrapper",
      function () {
        const $box = $(this).closest("[is-addone-modal-colors]");
        updateModelSliderArrows($box);
      },
    );

  window.calculateTabs = function (productId, variantId) {
    $(".pp_addon_poppup_accordion_container").hide();
    $(
      '.pp_addon_poppup_accordion_container[data-id="' + productId + '"]',
    ).show();

    const $product = $('.product-single__add-one[data-id="' + productId + '"]');
    const activeType = $product.find(".addone_item-switch.active").attr("data");

    const variantsCount = $(
      ".add--one--modal__handler--box[is-addone-modal-variants] .modal--variant__label",
    ).length;
    const doubleSwitchCount = $(
      ".add--one--modal__handler--box[is-addone-modal-variants] .addone_item-switch",
    ).length;

    if (activeType === "org") {
      let html = "";

      $product
        .find('.add-one__item.color .add-one__options input[type="radio"]')
        .each(function () {
          const $radio = $(this);
          const radioId = $radio.attr("id");

          const $label = $(`label[for="${CSS.escape(radioId)}"]`);
          if (!$label.length) return;

          const $ball = $label.find(".swatch-color-ball").first();

          const colorHandle = $ball.attr("data-color-handle");
          const vId = $ball.attr("data-variant-id");
          const style = $ball.attr("style") || "";
          const svg = $ball.find("svg").prop("outerHTML") || "";
          const colorName = $label
            .find(".product__variant-label-text_tooltip")
            .first()
            .text();

          const isChecked = $radio.is(":checked");
          const isDisabled =
            $radio.attr("available") === "false" ||
            $label.hasClass("addone-color-label-out") ||
            $label.closest(".addone-color-label-out").length;

          html += `
            <label class="modal--color__label ${isChecked ? "activelabel" : ""} ${isDisabled ? "addone-color-label-out" : ""}">
              <input type="radio" name="modal--color" ${isChecked ? "checked" : ""} ${isDisabled ? "disabled" : ""}>
              <span class="swatch-color-ball"
                    data-variant-id="${vId}"
                    data-color-handle="${colorHandle}"
                    style="${style}">
                ${svg}
              </span>
              <span class="product__variant-label-text_tooltip">${colorName}</span>
            </label>
          `;
        });

      const colorsCount = (html.match(/modal--color__label/g) || []).length;
      renderModalColors(html, {
        colorsCount,
        variantsCount,
        doubleSwitchCount,
      });
      return;
    }

    if (activeType === "second") {
      let html = "";
      const $proOptions = $product.find(".addone_color-option-out");

      $proOptions.each(function () {
        const $option = $(this);

        const $ball = $option.find(".swatch-color-ball").first();
        const colorHandle = $ball.attr("data-color-handle");
        const vId = $ball.attr("data-variant-id");
        const style = $ball.attr("style") || "";
        const svg = $ball.find("svg").prop("outerHTML") || "";
        const colorName = $option
          .find(".product__variant-label-text_tooltip")
          .first()
          .text();

        const uniqueID = $option.attr("data-unique-id");
        const isActive = $option.hasClass("active");
        const isDisabled = $option.hasClass("addone-color-label-out");

        html += `
          <label class="modal--color__label ${isActive ? "activelabel" : ""} ${isDisabled ? "addone-color-label-out" : ""}"
                 data-unique-id="${uniqueID}">
            <input type="radio" name="modal--color" ${isActive ? "checked" : ""} ${isDisabled ? "disabled" : ""}>
            <span class="swatch-color-ball"
                  data-variant-id="${vId}"
                  data-color-handle="${colorHandle}"
                  style="${style}">
              ${svg}
            </span>
            <span class="product__variant-label-text_tooltip">${colorName}</span>
          </label>
        `;
      });

      const colorsCount = $proOptions.length;

      renderModalColors(html, {
        colorsCount,
        variantsCount,
        doubleSwitchCount,
      });
      return;
    }
  };

  $(document).on("click", ".add-one__popup-opener", function () {
    $(".add-one_media_loader").css("display", "flex");
    $(".add-one_media_loader").addClass("activated");
    const $clickedElement = $(this).closest(".product-single__add-one");
    const $checkbox = $clickedElement.find('input[type="checkbox"]');
    var dataId = $checkbox.attr("data-id");
    var dataProductId = $(this).attr("data-product-id");

    $(".add--one--modal__content").attr("data-parent-id", "");

    var dataParentId = $(this)
      .closest(".add-one-crossell")
      .find(".add-one-crossell__main")
      .attr("data-id");

    $(".add--one--modal__content").attr("data-parent-id", dataParentId);

    $(".pp_addon_poppup_accordion_container").hide();
    $(
      '.pp_addon_poppup_accordion_container[data-id="' + dataProductId + '"]',
    ).show();

    console.log(dataProductId, "DATA PRODUCT ID OPENED");

    $(".addOneVariantSelection").removeClass("activeVariant");
    $(".addOneVariantSelection").each(function () {
      if ($(this).attr("data-id") == dataId) {
        $(this).addClass("activeVariant");
      }
    });

    var variantImageSource = $(".addOneVariantSelection.activeVariant").attr(
      "data-src",
    );

    $(".variantImage__js-addone").attr("src", variantImageSource);

    $("[is-addone-modal-checkbox]").attr("data-id", dataId);

    $(".modal--color__label").find("input[checked]").trigger("click");
  });

  $(document).on(
    "click",
    ".add--one--modal__image--list .video_container__popup",
    function () {
      var video = $(this).find("video").get(0);
      if (video) {
        if (video.paused) {
          video.play();
          $(this).find(".video_container__play-icon").hide();
        } else {
          video.pause();
          $(this).find(".video_container__play-icon").show();
        }
      }
    },
  );

  $(
    ".product .product-single__add-one .add-one__item fieldset .swatch-color-label.disabled",
  ).on("click mousedown mouseup keydown keyup", function (event) {
    event.preventDefault();
    event.stopPropagation();
  });

  $(
    ".product .product-single__add-one .add-one__item fieldset .swatch-color-label.disabled span",
  ).on("click mousedown mouseup keydown keyup", function (event) {
    event.preventDefault();
    event.stopPropagation();
  });

  function addDisablingToSwitcherInput() {
    $("label.addone-switcher-label-out").each(function () {
      var associatedInput = $(this).prev("input");
      if (associatedInput.length > 0) {
        associatedInput.prop("disabled", true);
      }
    });
  }

  window.clickedFromPopup = false;

  $(document).on("click", ".add--one--modal__handler--box", function (evt) {
    window.clickedFromPopup = true;
    setTimeout(function () {
      window.clickedFromPopup = false;
    }, 500);
  });

  $(document).on(
    "click",
    ".product-single__add-one .addonSwatcher_card",
    function (e) {
      if ($(".product_selection-all-box").hasClass("preloadNone")) {
        // Out of stock
      } else {
        console.log(window.clickedFromPopup, "CLICKED FROM POPUP");

        // if (window.clickedFromPopup == true) {
        //   return;
        // }

        if ($(this).hasClass("addone-color-label-out")) {
        } else {
          if (!$(".product-3d-window").hasClass("open")) {
            window.pdpSwiper?.slideTo(0);
          }
          if (window.mmqShowed == true) {
            $(".product-3d-window").addClass("open");
            $(".product__media-zoomin-btns").addClass("activated");
            if (typeof window.startPreloads === 'function') window.startPreloads();
          } else {
            if (typeof window.startPreloads === 'function') window.startPreloads();
            $(".loader.desktronic_loader_2step").show();

            const mmqInterval = setInterval(async () => {
              if (window.mmqLoaded) {
                console.log("mmq loaded 441");
                clearInterval(mmqInterval);
                $(".desktronic_loader3d_out").addClass("active2nd");
                $(".loader.desktronic_loader_2step").hide();
                $(".loader.desktronic_loader_3step").show();

                $(".product-3d-window").addClass("open");
                $(".product__media-zoomin-btns").addClass("activated");

                setTimeout(function () {
                  $(".loader.desktronic_loader_3step").hide();
                  window.stopPreloads();
                }, 3500);

                window.mmqShowed = true;
              }
            }, 200);
          }

          if ($(".product-3d-window").hasClass("open")) {
            setTimeout(function () {
              window.removePreloads();
              mmqLoadedDetectedAt = true;
            }, 2000);
          } else {
            var checkOpen = setInterval(function () {
              if ($(".product-3d-window").hasClass("open")) {
                clearInterval(checkOpen); // stop checking
              }
            }, 100);
          }
        }

        var thisEl = $(this);

        setTimeout(function () {
          var currentId = thisEl
            .closest(".product-single__add-one")
            .find(".addOneMainInput__js")
            .attr("data-id");
          var currentImg = $(
            '.pa_label_variant__js[data-id="' + currentId + '"]',
          ).attr("data-src");

          thisEl
            .closest(".product-single__add-one")
            .find(".add-one__image")
            .find("img")
            .attr("src", currentImg);

          thisEl
            .closest(".product-single__add-one")
            .find(".add-one__prices-current")
            .attr("data-variant-id", currentId);

          thisEl
            .closest(".product-single__add-one")
            .find(".add-one__prices-compare-at__money")
            .attr("data-variant-id", currentId);

          thisEl
            .closest(".product-single__add-one")
            .find(".add-one__discount")
            .attr("data-variant-id", currentId);

          // console.log(currentId, 'CHAIR ID IS');

          var currentPrice = $(
            '.config_upsell-chairs__js[data-id="' + currentId + '"]',
          ).attr("data-price");
          var currentComparePrice = $(
            '.config_upsell-chairs__js[data-id="' + currentId + '"]',
          ).attr("data-compare-price");
          var currentCompareFinalPrice = $(
            '.config_upsell-chairs__js[data-id="' + currentId + '"]',
          ).attr("data-compare-final-price");

          var currentDiscount = $(
            '.config_upsell-chairs__js[data-id="' + currentId + '"]',
          ).attr("data-addone-discount");

          thisEl
            .closest(".product-single__add-one")
            .find(".add-one__discount")
            .html(currentDiscount);
          thisEl
            .closest(".product-single__add-one")
            .find(".add-one__prices-current")
            .html(currentPrice);
          thisEl
            .closest(".product-single__add-one")
            .find(".add-one__prices-compare-at__money")
            .html(currentComparePrice);
          thisEl
            .closest(".product-single__add-one")
            .find(".add-one__prices-compare-at__money.final-compare-at")
            .html(currentCompareFinalPrice);
        }, 200);

        stopAllGalleryVideos();
      }
    },
  );

  // $('.product-3d-window').addClass('open');

  $(".addOneMainInput__js").change(function () {
    console.log(window.clickedFromPopup, "CLICKED FROM POPUP changed");

    window.calculateAddons();
    if (window.clickedFromPopup == true) {
      return;
    }

    if (!$(".product-3d-window").hasClass("open")) {
      window.pdpSwiper?.slideTo(0);
    }

    if (window.mmqShowed == true) {
      $(".product-3d-window").addClass("open");
      $(".product__media-zoomin-btns").addClass("activated");
      if (typeof window.startPreloads === 'function') window.startPreloads();
    } else {
      if (typeof window.startPreloads === 'function') window.startPreloads();
      $(".loader.desktronic_loader_2step").show();

      const mmqInterval = setInterval(async () => {
        if (window.mmqLoaded) {
          console.log("mmq loaded 504");
          clearInterval(mmqInterval);
          $(".desktronic_loader3d_out").addClass("active2nd");
          $(".loader.desktronic_loader_2step").hide();
          $(".loader.desktronic_loader_3step").show();
          $(".product-3d-window").addClass("open");
          $(".product__media-zoomin-btns").addClass("activated");

          setTimeout(function () {
            $(".loader.desktronic_loader_3step").hide();
            window.stopPreloads();
          }, 3500);

          window.mmqShowed = true;
        }
      }, 200);
    }

    if ($(".product-3d-window").hasClass("open")) {
      setTimeout(function () {
        window.removePreloads();
        mmqLoadedDetectedAt = true;
      }, 2000);
    } else {
      var checkOpen = setInterval(function () {
        if ($(".product-3d-window").hasClass("open")) {
          clearInterval(checkOpen); // stop checking
        }
      }, 100);
    }

    var currentId = $(this).attr("data-id");
    var currentImg = $(
      '.pa_label_variant__js[data-id="' + currentId + '"]',
    ).attr("data-src");
    console.log(currentId, currentImg);
    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__image")
      .find("img")
      .attr("src", currentImg);

    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__prices-current")
      .attr("data-id", currentId);

    $(this)
      .closest(".product-single__add-one")
      .find(".add-one__prices-compare-at__money")
      .attr("data-id", currentId);

    stopAllGalleryVideos();
  });

  $(document).on("click", ".js-qty", function () {
    var currentValue = $(this).find("input").val();
    console.log(currentValue);
    $(".mobile-sticky-atc-btn__wrapper").find(".qty__num").val(currentValue);
  });

  $(document).on("click", ".desktronic_loader3d_out.loader3d", function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
  });

  $(document).on("click", ".upsell_cart__button", function () {
    $(this).find(".desk_btn_content").css("opacity", "0");
    $(this).find(".desk_button_loader").show();
    $(this).find(".desk_btn_loader").show();
    $(this).addClass("loading");
  });

  $(document).on("click", "cart-remove-button", function () {
    $(this).addClass("loading");
  });

  $(document).on("click", ".drawer__footer .shipping", function () {
    $(this).addClass("loading");
  });

  $(".single-option-selector__radio").each(function () {
    const target = this;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === "class") {
          const $target = $(target);
          const hasDisabled = $target.hasClass("disabled-label");

          if (hasDisabled) {
            $target
              .closest(".swiper-slide")
              .find(".popular-badge")
              .addClass("hided_popuplar_badge");
          } else {
            $target
              .closest(".swiper-slide")
              .find(".popular-badge")
              .removeClass("hided_popuplar_badge");
          }
        }
      });
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["class"],
    });
  });

  $(".addonTypeSelection").click(function () {
    var currentTitle = $(this).attr("data-value-title");
    // alert(currentTitle);
    var currentValue = $(this)
      .closest(".hasMultiOptions")
      .find(".product__additional-variant")
      .attr("data-option");
    currentValue = String(currentValue).split("/");
    var newValue = currentValue[0] + "/ " + currentTitle;
    var clickedEl = $(this);
    setTimeout(function () {
      clickedEl
        .closest(".hasMultiOptions")
        .find(".product__additional-variant")
        .attr("data-option", newValue);
      clickedEl
        .closest(".hasMultiOptions")
        .find(".product__additional-variant")
        .find("input")
        .each(function () {
          var currentVal = $(this).attr("value");
          currentVal = String(currentVal).split("/");
          var newValue = currentVal[0] + "/ " + currentTitle;
          console.log(currentVal, "CURRENT VAL");
          console.log(newValue, "NEW VAL");
          $(this).attr("value", newValue);
        });
    }, 50);
  });

  $(document).on("click", ".product-single__add-one", function (event) {
    var thisEl = $(this);
    setTimeout(function () {
      var selectedId = thisEl.find(".addOneMainInput__js").attr("data-id");

      var selectedColor = $(
        '.add-one_variant_config[data-id="' + selectedId + '"]',
      ).attr("data-color");

      thisEl.find(".addOneMainInput__js").attr("data-color", selectedColor);
    });
  });

  $(document).on("click", ".product-single__add-ons__wrap", function () {
    window.calculateAddons();
  });

  $(document).on("click", ".product-single_read_more_btn", function () {
    var data = $(this).attr("data");
    if (data == "more") {
      // $('.product-single_read_more__less_part').hide();
      $(".product-single_read_more__full_part").css("display", "inline");
      $('.product-single_read_more_btn[data="less"]').css("display", "block");
      $('.product-single_read_more_btn[data="more"]').hide();
      $(".product-single_read_more_dots").hide();
    } else {
      // $('.product-single_read_more__less_part').show();
      $(".product-single_read_more__full_part").hide();
      $('.product-single_read_more_btn[data="less"]').hide();
      $('.product-single_read_more_btn[data="more"]').show();
      $(".product-single_read_more_dots").css("display", "inline");
    }
  });

  $(document).on("click", " .text_content-toggle", function () {
    var data = $(this).attr("data");
    if (data == "more") {
      $('.text_content-toggle[data="less"]').css("display", "inline");
      $('.text_content-toggle[data="more"]').hide();
      $(".text_content-collection-dots").hide();
      $(".text_content-collection-remaining").css("display", "inline");
    } else {
      $('.text_content-toggle[data="less"]').hide();
      $('.text_content-toggle[data="more"]').css("display", "inline");
      $(".text_content-collection-dots").css("display", "inline");
      $(".text_content-collection-remaining").hide();
    }
  });

  window.calculateAddons = function () {
    setTimeout(function () {
      var productQnt = 1;
      $(".add-one__3d-checked input:checked").each(function () {
        productQnt++;
      });

      // console.log(productQnt, ' quantity');
      if (productQnt > 1) {
        var atcText = $(".js-custom-add-to-cart")
          .attr("data-title-qnt")
          .replace("{}", productQnt);
        $(".desk_btn_content").find("span").html(atcText);
        $(".mobile-sticky-atc-btn__handlers")
          .find(".desk_btn_content")
          .html(atcText);
      } else {
        var atcText = $(".js-custom-add-to-cart").attr("data-title");
        $(".desk_btn_content").find("span").html(atcText);
        $(".mobile-sticky-atc-btn__handlers")
          .find(".desk_btn_content")
          .html(atcText);
      }
    }, 500);
  };

  function presetReviews() {
    var ReviewsSetted = 0;
    var intervalId = setInterval(function () {
      if (ReviewsSetted == 1) {
        clearInterval(intervalId);
        return;
      }
      var currentCounter = $(
        ".product__rating-wrapper .ruk-rating-snippet-count",
      ).html();
      if (typeof currentCounter != "undefined") {
        $(".main_product_rating_actual__js").html(currentCounter);
        ReviewsSetted = 1;
      }
    }, 200);
  }

  // presetReviews() disabled: the PDP header review count must come from Supabase
  // (set in desk_pdp_supa-reviews.js via .main_product_rating_actual__js), not the
  // legacy reviews.io rating-snippet widget — the two disagreed (widget showed a
  // different count than the Supabase mirror). See assets/claude-context.md reviews section.
  // presetReviews();

  $(document).on("click", ".js-qty__adjust", function () {
    var $el = $(this);
    var qty = parseInt(
      $(this).closest(".js-qty").find(".js-qty__num").val().replace(/\D/g, ""),
    );
    if ($el.hasClass("js-qty__adjust--plus")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 1) qty = 1;
    }
    $(this).closest(".js-qty").find(".js-qty__num").val(qty);
    $(".mobile-sticky-atc-btn__handlers").find(".qty__num").val(qty);
  });

  window.setStockNote = function () {
    setTimeout(function () {
      var currentId = $(".pp_config__main_id-js").attr("data-id");
      var currentStockCount = parseFloat(
        $('.oos-limit-reached_box.pdp[data-id="' + currentId + '"]').attr(
          "data-stock",
        ),
      );

      var currentPdpQuantity = parseFloat($(".js-qty__num").val());

      $(".oos-limit-reached_box.pdp").addClass("hided");

      if (currentPdpQuantity >= currentStockCount) {
        $(
          '.oos-limit-reached_box.pdp[data-id="' + currentId + '"]',
        ).removeClass("hided");
      } else {
        $(".oos-limit-reached_box.pdp").addClass("hided");
      }
    }, 50);
  };

  window.removeStockNote = function () {
    $(".oos-limit-reached_box.pdp").addClass("hided");
  };

  // $('.product__additional-variant .crossellProduct').click(function() {

  $(document).on("click", ".crossellProduct", function () {
    $(this)
      .closest(".product__additional-variant")
      .find(".crossellProduct")
      .removeClass("activeLabelInput");
    $(this).addClass("activeLabelInput");
    var forAttr = $(this).attr("for");
    var currentId = $(this).find(".swatch-color-ball").attr("data-variant-id");
    var currentMmqCode = $('input[id="' + forAttr + '"]').attr("data-mmq-code");
    var currentMmqCodeBlock = $('input[id="' + forAttr + '"]').attr(
      "data-mmq-block",
    );

    console.log(currentId, currentMmqCode, "CURRENT ID");

    $(this)
      .closest(".product-single__addone-label")
      .find(".addOneMainInput__js")
      .attr("data-id", currentId);

    $(this)
      .closest(".product-single__addone-label")
      .find(".addOneMainInput__js")
      .attr("data-mmq-code", currentMmqCode);
  });

  function setGalleryArrow() {
    var thumbsHeight = $(
      ".product .swiper-initialized .product-single__thumbnails",
    ).height();
    var mainBoxHeight = $(".product-single__media-group").height();
    if (thumbsHeight < mainBoxHeight) {
      $(".pp_gallery-scroll-down").hide();
    } else {
      $(".pp_gallery-scroll-down").show();
    }
  }

  setGalleryArrow();

  $(window).on("resize", function () {
    setGalleryArrow();
  });

  $(".product-gallery_opener_btn_outer").mouseover(function () {
    $(".opener-3D__tooltip").show();
    setTimeout(function () {
      $(".opener-3D__tooltip").addClass("active");
    }, 100);
  });

  $(".product-gallery_opener_btn_outer").mouseleave(function () {
    $(".opener-3D__tooltip").removeClass("active");
    setTimeout(function () {
      $(".opener-3D__tooltip").hide();
    }, 100);
  });

  var galleryWrapper = $(".product__gallery-wrapper");

  galleryWrapper.on("scroll", function () {
    var scrollTop = $(this).scrollTop();
    var scrollHeight = $(this)[0].scrollHeight;
    var wrapperHeight = $(this).innerHeight();

    var isScrolledDown = scrollTop > 10;
    $(".pp_gallery-scroll-up").toggleClass("is-visible", isScrolledDown);
    $(".pp_gallery-scroll-up--btn").css("display", isScrolledDown ? "flex" : "none");

    // Detect if scrolled to bottom
    if (scrollTop + wrapperHeight >= scrollHeight - 1) {
      // -1 for safe rounding
      console.log("Scrolled to the bottom");
      $(".pp_gallery-scroll-down").hide();
    } else {
      $(".pp_gallery-scroll-down").css("display", "flex");
    }
  });

  $(".pp_gallery-scroll-up--btn").click(function () {
    var galleryWrapper = $(".product__gallery-wrapper");
    var currentScroll = galleryWrapper.scrollTop();
    galleryWrapper.scrollTop(currentScroll - 200);
  });

  $(".pp_gallery-scroll-down--btn").click(function () {
    var galleryWrapper = $(".product__gallery-wrapper");
    var currentScroll = galleryWrapper.scrollTop();
    galleryWrapper.scrollTop(currentScroll + 200);
  });

  function setVariant(variantId) {
    var variantSrc =
      (window.deskVariantImages && window.deskVariantImages[variantId]) ||
      $('.pp_variant_config[data-id="' + variantId + '"]').attr(
        "data-featured-img",
      );
    $("#product-variant__src").attr("src", variantSrc);
    $("#product-variant__thumb").attr("src", variantSrc);
    $(".product_thumb-sticky").attr("src", variantSrc);
    if (variantSrc) $(".desk_sticky-atc__img").attr("src", variantSrc);
  }

  // Specs info
  $(document).on("click", ".product_tabletop-nav-btn", function () {
    var $btn = $(this);
    var currentData = $btn.attr("data");
    var $layout = $btn.closest(".product_spec_box-layout");

    $layout.find(".product_tabletop-nav-btn").removeClass("active");
    $btn.addClass("active");

    $layout.find(".product_spec-size-info").addClass("hided");
    $layout.find('.product_spec-size-info[data="' + currentData + '"]').removeClass("hided");
  });

  $(document).on("click", ".product_spec-tabletops-switcher-btn", function () {
    $(".product_spec-tabletops-switcher-btn").removeClass("active");
    $(this).addClass("active");
    var currentData = $(this).attr("data");
    $(".product_spec_box-layout.product_spec-tabletops").addClass("hided");
    $(
      '.product_spec_box-layout.product_spec-tabletops[data="' +
        currentData +
        '"]',
    ).removeClass("hided");

    $(".product_arm-image-box").addClass("hided");
    $('.product_arm-image-box[data="' + currentData + '"]').removeClass(
      "hided",
    );
  });

  $(".product_specs_box").click(function (e) {
    // if the click happened inside the content area, ignore it
    if ($(e.target).closest(".product_spec-tab-content").length) {
      return;
    }

    const $box = $(this);
    const $content = $box.find(".product_spec-tab-content");

    if ($content.is(":animated")) return; // ignore while animating

    $box.toggleClass("active");
    $content.slideToggle();
  });

  $(document).keyup(function (e) {
    if (e.key === "Escape") {
      $(".product-charity-outer_whole").hide();
      $(".product-colors-comparison_outer").hide();
      $(".product-comparison-outer_whole").hide();
      $(".product-price-comparison_outer").hide();
      $(".product-price-outer_whole").hide();
      $("body").removeClass("popup-open");
      window.unlockScroll();
    }
  });

  $(".product-price-comparison_outer").click(function (e) {
    if (!$(e.target).closest(".product-price-comparison_popup").length) {
      $(".product-price-comparison_outer").hide();
      $(".product-price-outer_whole").hide();
      $("body").removeClass("popup-open");
      window.unlockScroll();
    }
  });

  $(".product-charity-outer_whole").click(function (e) {
    if (!$(e.target).closest(".product-charity-comparison_popup").length) {
      $(".product-charity-outer_whole").hide();
      $("body").removeClass("popup-open");
    }
  });

  $(".product-comparison-outer_whole").click(function (e) {
    if (!$(e.target).closest(".product-colors-comparison_popup").length) {
      $(".product-comparison-outer_whole").hide();
      $("body").removeClass("popup-open");
      window.unlockScroll();
    }
  });

  $(".tree-banner__button").click(function (evt) {
    evt.preventDefault();
    $(".product-charity-outer_whole").show();
    $("body").addClass("popup-open");
    $(".product-charity-comparison_outer").css("display", "flex");
    var winHeight = $(window).height();
    if (winHeight > 1000) {
      if ($(window).width() > 678) {
        var popupHeight = $(".product-charity-comparison_popup").outerHeight();
        $(".product-charity-popup_close").css(
          "top",
          "calc(50% - " + popupHeight / 2 + "px + 16px)",
        );
        $(".product-charity-comparison_outer").css("align-items", "center");
      }
    } else {
      $(".product-charity-comparison_outer").css("align-items", "flex-start");
      $(".product-charity-popup_close").css("top", "72px");
    }
  });

  $(".hero-press_cell").click(function () {
    $(".hero-press_title_box").css("opacity", "0");
    $(".hero-press_cell").removeClass("active");
    $(this).addClass("active");
    var currentId = $(this).attr("data-id");
    setTimeout(function () {
      $(".hero-press_title").addClass("hided");
      $('.hero-press_title[data-id="' + currentId + '"]').removeClass("hided");
      $(".hero-press_title_box").css("opacity", "1");
    }, 500);
  });

  $(".hero-press_cell").mouseover(function () {
    $(this).trigger("click");
  });

  $(".hero-press_wrapper").each(function () {
    var $root = $(this);
    var $scroller = $root.find(".hero-press_grid-wrapper");
    var INTERVAL = window.press_logos_interval || 6000;
    var auto = null,
      hovering = false;

    function isMobile() {
      return window.matchMedia("(max-width: 678px)").matches;
    }

    function getCells() {
      return isMobile()
        ? $root.find(".Mobile_only .hero-press_cell")
        : $root.find(".Desktop_only .hero-press_cell");
    }

    function getActive() {
      var $cells = getCells();
      var $active = $cells.filter(".active").first();
      return $active.length ? $active : $cells.first();
    }

    function clampScroll(x) {
      var el = $scroller.get(0);
      var max = Math.max(0, el.scrollWidth - el.clientWidth);
      return Math.max(0, Math.min(x, max));
    }

    function scrollActiveIntoView() {
      if (!isMobile()) return;
      var $active = getActive();
      if (!$active.length) return;

      var el = $scroller.get(0);
      var curr = el.scrollLeft;
      var aRect = $active.get(0).getBoundingClientRect();
      var sRect = el.getBoundingClientRect();
      var delta = aRect.left - sRect.left;
      var centerOffset = sRect.width / 2 - aRect.width / 2;
      var target = clampScroll(curr + delta - centerOffset);

      $scroller.stop().animate({ scrollLeft: target }, 300);
    }

    function stopAuto() {
      if (auto) {
        clearInterval(auto);
        auto = null;
      }
    }
    function startAuto() {
      stopAuto();
      auto = setInterval(goNext, INTERVAL);
    }
    function resetAuto(forceStart) {
      stopAuto();
      if (forceStart || !hovering) startAuto();
    }

    function activate($cell, isManual) {
      var $grid = $cell.closest(".hero-press_grid");
      $grid.find(".hero-press_cell").removeClass("active");
      $cell.addClass("active");

      $(".hero-press_title_box").css("opacity", "0");
      var currentId = $cell.attr("data-id");
      setTimeout(function () {
        $(".hero-press_title").addClass("hided");
        $('.hero-press_title[data-id="' + currentId + '"]').removeClass(
          "hided",
        );
        $(".hero-press_title_box").css("opacity", "1");
      }, 200);

      setTimeout(scrollActiveIntoView, 0);

      if (isManual) {
        // Desktop: respect hover-pause; Mobile: always keep looping (reset timer)
        resetAuto(isMobile());
      }
    }

    function goNext() {
      var $cells = getCells();
      if (!$cells.length) return;

      var total = $cells.length;
      var $active = getActive();
      var currIndex = Number($active.data("index")) || 1;

      var nextIndex = currIndex + 1;

      if (isMobile()) {
        // If we would move onto the very last item, instead jump to #2
        if (nextIndex === total) {
          nextIndex = 2;
        } else if (nextIndex > total) {
          nextIndex = 2; // safety
        }
      } else {
        if (nextIndex > total) nextIndex = 1; // desktop: normal wrap
      }

      var $next = $cells.filter('[data-index="' + nextIndex + '"]').first();
      if ($next.length) activate($next, false);
    }

    $root.on("click", ".hero-press_cell", function (e) {
      activate($(this), !e.isTrigger);
    });

    // Pause on hover ONLY on desktop; on mobile just reset the timer so it keeps looping
    $root.on("mouseenter", function () {
      if (isMobile()) {
        resetAuto(true);
      } else {
        hovering = true;
        stopAuto();
      }
    });
    $root.on("mouseleave", function () {
      if (isMobile()) {
        resetAuto(true);
      } else {
        hovering = false;
        startAuto();
      }
    });
    // Touch interactions on mobile should also just reset the timer
    $root.on("touchstart touchend touchcancel", function () {
      if (isMobile()) resetAuto(true);
    });

    $(window).on("resize", function () {
      scrollActiveIntoView();
      if (isMobile() && !auto) startAuto();
    });

    startAuto();

    // On load: select the 2nd item and center it on mobile
    if (isMobile()) {
      var $second = $root
        .find('.Mobile_only .hero-press_cell[data-index="2"]')
        .first();
      if ($second.length) activate($second, false);
      else setTimeout(scrollActiveIntoView, 0);
    }
  });

  $(".collection_seo_nav-btn-grid_wrapper-outer").each(function () {
    var $outer = $(this),
      $s = $outer.find(".collection_seo_nav-btn-grid_wrapper"),
      $r = $outer.find(".collection-seo_nav_arrow--right"), // arrow IMG (right)
      $l = $outer.find(".collection-seo_nav_arrow--left"), // arrow IMG (left)
      $or = $outer.find(".collection-seo_nav_right-box-overlay"),
      $ol = $outer.find(".collection-seo_nav_left-box-overlay"),
      STEP = 200;

    function max() {
      var el = $s[0];
      return Math.max(0, el.scrollWidth - el.clientWidth);
    }

    function update() {
      var sl = $s.scrollLeft(),
        m = max();
      $l.toggleClass("hided", sl <= 0);
      $ol.toggleClass("hided", sl <= 0);
      $r.toggleClass("hided", sl >= m - 1);
      $or.toggleClass("hided", sl >= m - 1);
    }

    function slide(dx) {
      var target = Math.max(0, Math.min($s.scrollLeft() + dx, max()));
      $s.stop().animate({ scrollLeft: target }, 250, update);
    }

    // Click only on arrow images, and ALSO on the overlays
    $r.add($or).on("click", function (e) {
      e.preventDefault();
      slide(STEP);
    });
    $l.add($ol).on("click", function (e) {
      e.preventDefault();
      slide(-STEP);
    });

    $s.on("scroll", update);
    $(window).on("resize", update);

    update();
  });

  $(".influ-popup_close").click(function () {
    closeInfluPopup();
  });

  $(document).on("click", ".influ-popup_outer", function (e) {
    if (!$(e.target).closest(".influ-popup_inner").length) {
      closeInfluPopup();
    }
  });

  function closeInfluPopup() {
    $(".influ-popup_outer-whole").hide();
    $(".influ-popup_close").hide();
    $("body").removeClass("modal--open");
  }

  $(".certificates_scroll-area-outer").each(function () {
    var $outer = $(this);
    var $area = $outer.find(".certificates_scroll-area");
    var $prev = $outer.find(".certificates_scroll-arrow-prev");
    var $next = $outer.find(".certificates_scroll-arrow-next");
    var step = 300;

    function maxScroll() {
      var el = $area.get(0);
      return Math.max(0, el.scrollWidth - el.clientWidth);
    }

    function updateArrows() {
      var sl = $area.scrollLeft();
      var m = maxScroll();
      if (sl <= 0) $prev.addClass("hided");
      else $prev.removeClass("hided");
      if (sl >= m - 1) $next.addClass("hided");
      else $next.removeClass("hided");
    }

    function scrollBy(dx) {
      var target = Math.max(0, Math.min(maxScroll(), $area.scrollLeft() + dx));
      $area.stop().animate({ scrollLeft: target }, 250, updateArrows);
    }

    $prev.on("click", function (e) {
      e.preventDefault();
      scrollBy(-step);
    });
    $next.on("click", function (e) {
      e.preventDefault();
      scrollBy(step);
    });

    var ticking = false;
    $area.on("scroll", function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateArrows();
          ticking = false;
        });
        ticking = true;
      }
    });

    $(window).on("resize", updateArrows);
    setTimeout(updateArrows, 0);
  });

  // Accessories videos

  function getPopupEls() {
    const $popup = $(".product_accessories-video-popup");
    const $inner = $popup.find(".product_accessories-video-popup-inn");
    const $close = $popup.find(".product_accessories-popup-close");
    const $video = $popup.find(".product_acc-video");
    const video = $video.get(0);
    const $source = $video.find("source");
    return { $popup, $inner, $close, $video, video, $source };
  }

  function openMobileVideo(src) {
    const { $popup, $close, video, $source } = getPopupEls();
    if (!video) return;

    if (src) $source.attr("src", src);
    video.muted = true;
    video.playsInline = true;
    try {
      video.load();
    } catch (_) {}

    $popup.css("display", "flex");

    const p = video.play?.();
    if (p && typeof p.catch === "function") p.catch(() => {});
  }

  function closeMobileVideo() {
    const { $popup, $close, video, $source } = getPopupEls();
    if (!video) return;

    try {
      video.pause();
    } catch (_) {}
    try {
      video.currentTime = 0;
    } catch (_) {}
    $source.attr("src", "");
    try {
      video.load();
    } catch (_) {}

    $popup.hide();
  }

  $(document).on("click", ".product_acc-video-play--btn", function (e) {
    e.stopPropagation();

    if ($(window).width() > 960) {
      $(".product_accessories-video-block")
        .removeClass("active")
        .each(function () {
          const video = $(this).find(".product_acc-video").get(0);
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        });

      const block = $(this).closest(".product_accessories-video-block");
      block.addClass("active");

      const video = block.find(".product_acc-video").get(0);
      if (video) {
        video.currentTime = 0;
        video.play();
      }
    } else {
      const $block = $(this).closest(".product_accessories-video-block");
      let src =
        $(this).data("videoSrc") ||
        $block.data("videoSrc") ||
        $block.find(".product_acc-video source").attr("src") ||
        "";
      openMobileVideo(src);
    }

    const $slide = $(this).closest(".swiper-slide");
    if ($slide.length && window.limitedSwiper) {
      window.limitedSwiper.slideTo($slide.index(), 1000);
    }
  });

  $(document).on("click", ".product_acc-video-top--btn", function (e) {
    e.stopPropagation();
    if ($(window).width() > 960) {
      const block = $(this).closest(".product_accessories-video-block");
      block.removeClass("active");

      const video = block.find(".product_acc-video").get(0);
      if (video) {
        video.pause();
        video.currentTime = 0;
      }

      window.updateArrows();
    }
  });

  $(document).on("click", ".product_accessories-video-block", function (e) {
    if (
      $(e.target).closest(
        ".product_acc-video-play--btn, .product_acc-video-top--btn",
      ).length
    )
      return;

    if (!$(this).hasClass("active")) {
      $(this).find(".product_acc-video-play--btn").trigger("click");
    }

    if ($(window).width() <= 960) return;

    const wrapper = document.querySelector(".swiper_accessoires_wrapper-outer");
    const block = this;
    if (!wrapper || !block) return;

    setTimeout(() => {
      const scrollLeft =
        block.offsetLeft - wrapper.clientWidth / 2 + block.offsetWidth / 2;
      const max = wrapper.scrollWidth - wrapper.clientWidth;
      wrapper.scrollTo({
        left: Math.max(0, Math.min(scrollLeft, max)),
        behavior: "smooth",
      });
      setTimeout(() => window.updateArrows && window.updateArrows(), 300);
    }, 250);
  });

  $(document).on("click", ".product_accessories-popup-close", function (e) {
    e.stopPropagation();
    closeMobileVideo();
  });

  $(document).on("click", ".product_accessories-video-popup", function (e) {
    if (!$(e.target).closest(".product_accessories-video-popup-inn").length) {
      closeMobileVideo();
    }
  });

  $(document).on(
    "click",
    ".product_accessories-video-block.active .product_acc-video",
    function (e) {
      if ($(window).width() > 768) {
        e.stopPropagation();

        const block = $(this).closest(".product_accessories-video-block");
        block.removeClass("active");

        const video = $(this).get(0);
        if (video) {
          video.pause();
          video.currentTime = 0;
        }

        window.updateArrows();
      }
    },
  );

  document
    .querySelector(".swiper_accessoires_wrapper-outer")
    ?.addEventListener("scroll", window.updateArrows);

  window.addEventListener("load", window.updateArrows);
  window.addEventListener("resize", window.updateArrows);

  $(document).on("keydown.videoPopup", function (e) {
    if (e.key === "Escape" || e.keyCode === 27) closeMobileVideo();
  });

  $(document).on("click", ".product-single__thumbnail", function (event) {
    event.preventDefault();
    // The thumb's index in the strip = the main slide index (1:1 order). Use the
    // DOM index directly — simple and reliable — and route through the same mover
    // the arrows use so the counter stays in sync.
    var firstNumber = $('.product_main_gallery_thumbs__js .swiper-slide').index($(this).closest('.swiper-slide'));
    if (firstNumber < 0 || !window.pdpSwiper) return;
    if (typeof window.pdpGoToSlide === 'function') {
      window.pdpGoToSlide(firstNumber);
    } else {
      window.pdpSwiper.slideTo(firstNumber);
    }
    if (firstNumber === 0 && $('.product__media-zoomin-btns').hasClass('activated')) {
      $('.product-3d-window').addClass('open');
    }
  });

  function deskLoadGallerySlide(index, urgent) {
    if (index < 0) return;
    var $img = $('.mySwiper2 .swiper-slide').eq(index).find('img[data-srcset]');
    if (!$img.length) return;

    var thumbSrc = $('.product_main_gallery_thumbs__js .swiper-slide').eq(index).find('img').attr('src');

    $img.each(function () {
      var $this = $(this);
      if (thumbSrc) $this.css('background', 'url("' + thumbSrc + '") center / cover no-repeat');
      if (urgent) $this.attr('fetchpriority', 'high');
      $this.attr('srcset', $this.attr('data-srcset')).attr('src', $this.attr('data-src'));
      $this.removeAttr('data-srcset data-src');
    });
  }

  function deskLoadGalleryAround(index) {
    index = index || 0;
    deskLoadGallerySlide(index, true);
    deskLoadGallerySlide(index + 1);
    deskLoadGallerySlide(index - 1);
    $(document).trigger("desk:gallery-slide", [index]);
  }

  function deskThumbIndex(thumb) {
    return $('.product_main_gallery_thumbs__js .swiper-slide').index($(thumb).closest('.swiper-slide'));
  }

  window.deskLoadGallerySlide = deskLoadGallerySlide;
  window.deskLoadGalleryAround = deskLoadGalleryAround;

  $(document).on("mouseenter", ".product-single__thumbnail", function () {
    deskLoadGallerySlide(deskThumbIndex(this), true);
  });

  $(document).on("pointerdown", ".product-single__thumbnail", function (event) {
    if (event.originalEvent.button !== 0) return;
    var index = deskThumbIndex(this);
    deskLoadGallerySlide(index, true);
    if (event.originalEvent.pointerType === "mouse" && index >= 0 && typeof window.pdpGoToSlide === "function") {
      window.pdpGoToSlide(index);
    }
  });

  $(document).on("mouseenter touchstart", ".mySwiper2, .slider__gallery-item-btn", function () {
    deskLoadGalleryAround(window.pdpGalleryIndex);
  });

  $(".banner-small_button").click(function () {
    var dataTrigger = $(this).attr("data-value");
    $("html, body").animate(
      {
        scrollTop: $("" + dataTrigger + "").offset().top - 50,
      },
      500,
    );
  });

  $(".mob_banner-smalle-clickable").click(function () {
    var dataTrigger = $(this).attr("data-value");
    $("html, body").animate(
      {
        scrollTop: $("" + dataTrigger + "").offset().top - 50,
      },
      500,
    );
  });

  $(".card__wrapper").click(function (evt) {
    // Collection cards render .card__wrapper AS the link (<a class="card__wrapper">),
    // so we cancel its default. But b2b cards use a <div class="card__wrapper"> with a
    // real link inside (.card__btn) — don't swallow clicks on nested links/buttons.
    var interactive = $(evt.target).closest("a, button")[0];
    if (interactive && interactive !== this) return;
    evt.preventDefault();
  });

  $(document).on("click", ".add--one--modal__handler--label", function (event) {
    $(".add--one--modal__handler--label").css("pointer-events", "none");
    setTimeout(function () {
      $(".add--one--modal__handler--label").css("pointer-events", "unset");
    }, 1000);
  });

  $('.desk_pdp-accordion-block').click(function(e){
    if ($(e.target).closest('.desk_pdp-accordion-content').length) return;
    $(this).toggleClass('active');
    $(this).find('.desk_pdp-accordion-content').slideToggle();
  });

  function ugc_testimonials__initSlider() {
    var $wrapper = $('.ugc-testimonials__slider__wrapper');
    if (!$wrapper.length) return;

    var $next = $('.ugc-testimonial__slider_arrow.next');
    var $prev = $('.ugc-testimonial__slider_arrow.prev');
    var $shadowLeft = $('.ugc-testimonials__slider_shadow.left');
    var $shadowRight = $('.ugc-testimonials__slider_shadow.right');

    function ugc_testimonials__updateArrows() {
      var scrollLeft = $wrapper.scrollLeft();
      var maxScroll = $wrapper[0].scrollWidth - $wrapper[0].clientWidth;
      var atStart = scrollLeft <= 0;
      var atEnd = scrollLeft >= maxScroll - 1;
      $prev.toggleClass('disabledArrow', atStart);
      $next.toggleClass('disabledArrow', atEnd);
      $shadowLeft.toggleClass('disabledShadow', atStart);
      $shadowRight.toggleClass('disabledShadow', atEnd);
    }

    var ugc_testimonials__pendingScroll = $wrapper.scrollLeft();

    function ugc_testimonials__getNextCellLeft() {
      var target = null;
      $('.ugc-testimonial__cell').each(function() {
        var cellLeft = $(this).position().left + ugc_testimonials__pendingScroll;
        if (cellLeft > ugc_testimonials__pendingScroll + 1) { target = cellLeft; return false; }
      });
      return target;
    }

    function ugc_testimonials__getPrevCellLeft() {
      var target = null;
      $('.ugc-testimonial__cell').each(function() {
        var cellLeft = $(this).position().left + ugc_testimonials__pendingScroll;
        if (cellLeft < ugc_testimonials__pendingScroll - 1) target = cellLeft;
      });
      return target;
    }

    function ugc_testimonials__stopAll() {
      $('.ugc-testimonial__cell').each(function() {
        var video = $(this).find('.ugc-testimonial__video')[0];
        video.pause();
        video.currentTime = 0;
        $(this).find('.ugc-testimonial__placeholder').show();
        $(this).find('.ugc-testimonial__play').show();
      });
    }

    $next.on('click', function() {
      if ($(this).hasClass('disabledArrow')) return;
      var target = ugc_testimonials__getNextCellLeft();
      if (target !== null) {
        ugc_testimonials__pendingScroll = target;
        $wrapper.stop(true).animate({ scrollLeft: target }, 300);
      }
    });

    $prev.on('click', function() {
      if ($(this).hasClass('disabledArrow')) return;
      var target = ugc_testimonials__getPrevCellLeft();
      if (target !== null) {
        ugc_testimonials__pendingScroll = target;
        $wrapper.stop(true).animate({ scrollLeft: target }, 300);
      }
    });

    $(document).on('mouseenter', '.ugc-testimonial__cell', function() {
      var $cell = $(this);
      var video = $cell.find('.ugc-testimonial__video')[0];
      var $placeholder = $cell.find('.ugc-testimonial__placeholder');
      var $source = $cell.find('source[data-src]');
      if ($source.length) {
        $source.attr('src', $source.attr('data-src')).removeAttr('data-src');
        video.load();
      }
      video.muted = true;
      $(video).one('playing', function() {
        $placeholder.hide();
      });
      video.play();
    });

    $(document).on('mouseleave', '.ugc-testimonial__cell', function() {
      var $cell = $(this);
      var video = $cell.find('.ugc-testimonial__video')[0];
      video.pause();
      video.currentTime = 0;
      $cell.find('.ugc-testimonial__placeholder').show();
    });

    $(document).on('click', '.ugc-testimonial__cell', function() {
      var $cell = $(this);
      var cellVideo = $cell.find('.ugc-testimonial__video')[0];
      cellVideo.pause();
      $cell.find('.ugc-testimonial__placeholder').show();
      var $source = $cell.find('source');
      var src = $source.attr('src') || $source.attr('data-src');
      if (!src) return;
      ugc_openPopup(src);
    });

    $next.add($prev).on('click', ugc_testimonials__stopAll);

    var ugcSliderHovered = false;
    $('.ugc-testimonials__slider__wrapper_outer').on('mouseenter', function() {
      ugcSliderHovered = true;
    }).on('mouseleave', function() {
      ugcSliderHovered = false;
    });

    $(document).on('keydown.ugcslider', function(e) {
      if (!ugcSliderHovered) return;
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        if (!$next.hasClass('disabledArrow')) {
          var targetNext = ugc_testimonials__getNextCellLeft();
          if (targetNext !== null) {
            ugc_testimonials__pendingScroll = targetNext;
            $wrapper.stop(true).animate({ scrollLeft: targetNext }, 300);
          }
        }
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        if (!$prev.hasClass('disabledArrow')) {
          var targetPrev = ugc_testimonials__getPrevCellLeft();
          if (targetPrev !== null) {
            ugc_testimonials__pendingScroll = targetPrev;
            $wrapper.stop(true).animate({ scrollLeft: targetPrev }, 300);
          }
        }
      }
    });

    $wrapper.on('scroll', ugc_testimonials__updateArrows);
    ugc_testimonials__updateArrows();
  }

  var $ugcPopup = $(
    '<div class="ugc-video-popup">' +
      '<div class="ugc-video-popup__inner">' +
        '<button class="ugc-video-popup__close" aria-label="Close">' +
          '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">' +
            '<path d="M0.21967 0.21967C0.512563 -0.0732233 0.987324 -0.0732233 1.28022 0.21967L11.6904 10.6298C11.9831 10.9227 11.9832 11.3975 11.6904 11.6904C11.3975 11.9832 10.9227 11.9831 10.6298 11.6904L0.21967 1.28022C-0.0732233 0.987324 -0.0732233 0.512563 0.21967 0.21967Z" fill="white"/>' +
            '<path d="M10.6298 0.21967C10.9227 -0.0731452 11.3975 -0.0731972 11.6904 0.21967C11.9832 0.512544 11.9832 0.987343 11.6904 1.28022L1.28022 11.6904C0.987343 11.9832 0.512544 11.9832 0.21967 11.6904C-0.0731972 11.3975 -0.0731452 10.9227 0.21967 10.6298L10.6298 0.21967Z" fill="white"/>' +
          '</svg>' +
        '</button>' +
        '<video class="ugc-video-popup__video" controls playsinline loop></video>' +
      '</div>' +
    '</div>'
  );
  $('body').append($ugcPopup);

  function ugc_openPopup(src) {
    var video = $ugcPopup.find('.ugc-video-popup__video')[0];
    var $inner = $ugcPopup.find('.ugc-video-popup__inner');
    $inner.removeClass('vertical');
    video.src = src;
    video.load();
    $(video).off('loadedmetadata.ugcpopup').on('loadedmetadata.ugcpopup', function() {
      if (this.videoHeight > this.videoWidth) $inner.addClass('vertical');
    });
    $ugcPopup.addClass('active');
    document.body.classList.add('popup-open');
    if (window.lockScroll) window.lockScroll();
    setTimeout(function() { video.play(); }, 300);
  }

  function ugc_closePopup() {
    var video = $ugcPopup.find('.ugc-video-popup__video')[0];
    $ugcPopup.removeClass('active');
    document.body.classList.remove('popup-open');
    if (window.unlockScroll) window.unlockScroll();
    video.pause();
  }

  $ugcPopup.find('.ugc-video-popup__close').on('click', ugc_closePopup);
  $ugcPopup.on('click', function(e) {
    if (!$(e.target).closest('.ugc-video-popup__inner').length) ugc_closePopup();
  });
  $(document).on('keydown.ugcpopup', function(e) {
    if (e.key === 'Escape' && $ugcPopup.hasClass('active')) ugc_closePopup();
  });

  ugc_testimonials__initSlider();


});